import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { DateInterval } from "./date-interval";
import { MetricOptionRequestResource } from "./metric-option-request-resource";
import type { RequestedAggregationType } from "./requested-aggregation-type";

@JsonObject()
export class AggregationRequestResource {
    @JsonProperty("name")
    name: string;

    @JsonProperty("field")
    field: string;

    @JsonProperty("size")
    size: number = 10;

    @JsonProperty("datasource")
    optionList: string = "";

    @JsonProperty("children")
    @JsonElementType(AggregationRequestResource)
    children: Array<AggregationRequestResource> = [];

    @JsonProperty("metric_option")
    metricOption?: MetricOptionRequestResource;

    @JsonProperty("type")
    requestedAggregationType?: RequestedAggregationType;

    @JsonProperty("interval")
    interval?: DateInterval;

    @JsonProperty("format")
    format?: string;

    @JsonProperty("include_missing")
    includeMissing?: boolean = false;

    constructor(init?: Partial<AggregationRequestResource>) {
        Object.assign(this, init);
    }
}
